import React from 'react';
import { Provider } from 'react-redux';
import store from '../../state';

import Map from './Map';

const MapContainer = props => (
  <Provider store={store}>
    <Map {...props} />
  </Provider>
);

export default MapContainer;
